import './page.scss';

document.addEventListener('DOMContentLoaded', function() {
    const bubble = document.querySelector('.bubble');
    const clickButton = document.querySelector('.click-button');
    const closeButton = document.querySelector('.close-button');
    const widgetImage = document.querySelector('.globie-widget-image');

    const isClosed = localStorage.getItem('globie_bubble_status') === 'closed';

    if (isClosed && bubble) {
        bubble.classList.add('closed');
    } else if (bubble) {
        setTimeout(function() {
            if (!bubble.classList.contains('closed')) {
                bubble.classList.add('open');
            }
        }, 2000);
    }

    if (closeButton && bubble) {
        closeButton.addEventListener('click', function(e) {
            e.stopPropagation();
            bubble.classList.add('closed');
            bubble.classList.remove('open');
            bubble.classList.remove('active');
            
            localStorage.setItem('globie_bubble_status', 'closed');
        });
    }

    if (widgetImage && bubble) {
        widgetImage.addEventListener('click', function() {
            bubble.classList.add('open');
            bubble.classList.remove('closed');
            
            localStorage.removeItem('globie_bubble_status');
        });
    }

    if (clickButton && bubble) {
        clickButton.addEventListener('click', function() {
            bubble.classList.toggle('active');
        });
    }
});